import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureNotSupportedComponent } from './feature-not-supported.component';
import { SharedModule } from '../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    FeatureNotSupportedComponent
  ],
  exports: [
    FeatureNotSupportedComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule,
    MatDividerModule,
  ]
})
export class FeatureNotSupportedModule { }
